fx.translations("es", {

     "Commander" : "Encargar",
     "Total" : "Total",
     "(hors livraison) :" : "(excluyendo envío) :",
     "Votre ouvrage contient" : "Su libro contiene",
     "pages": "páginas",
     "Sauver & Quitter" : "Guardar y salir",

     "Carré" : "Cuadrado",
     "Portrait" : "Vertical",
     "Paysage" : "Apaisado",

     "Rechercher" : "Buscar",
     "Ajouter" : "Añadir",
     "Modifier" : "Modificar",

     "Couleur" : "Color",

     "Réglages" : "Ajustes",

     "Prix" : "Precio",

     "Album"  : "Álbum",

     "Recommandés" : "Recomendado",

     "Photos" : "Fotos",
     "Modèles" : "Diseños",
     "Textes" : "Textos",
     "Fonds" : "Fondos",
     "Stickers" : "Pegatinas",

     "Chargement ..." : "Cargando ...",

     "Luminosité" : "Luminosidad",
     "Saturation" : "Saturación",
     "Contraste" : "Contraste",

     "couverture" : "tapa",

     "Ok" : "Ok",
     "OK" : "OK",

     "$ photos": "$ fotos",

     "Vue globale" : "Visión global",
     "Zoomer" : "Zoom",

     "Editeur" : "Editor",

     "Total" : "Total",
     "hors livraison" : "excluida entrega",
     
     "Trier par ordre d'ajout" : "Ordenar por orden de adición",
     "Trier par date de photo" : "Ordenar por fecha de la foto",
     "Masquer les photos utilisées" : "Ocultar fotos utilizadas",

     "Ajouter un titre" : "Añadir título",
     "Ajouter du texte" : "Añadir texto",
     "Modèles à personnaliser" : "Textos personalizables",

     "Récupération des photos" : "Cargando fotos",
     "Ajouter $ photo$" : "Importar $ foto$",
     
	 // popups
      "J'ai vérifié votre album, et j'ai constaté cela :" : "He encontrado estos problemas en tu álbum:",
      
      "Ca sera rapide ..." : "Será rápido ...",
      "Il semble que la connexion soit un peu lente..." : "Parece que la conexión es lenta",
      "La connexion doit vraiment être trop lente..." : "La conexión es demasiado lenta",
      "La connexion est un peu lente..." : "La conexión es un poco lenta...",
      "J'essai de nouveau..." : "Lo intento de nuevo...",
      "Encore quelques secondes..." : "Unos segundos más...",
      "La connexion est trop lente..." : "La conexión es demasiado lenta",
      "J'insiste encore..." : "Sigo insistiendo",
      "On devrait y être bientôt..." : "Ya casi estamos",
      "Je sauvegarde" : "Estoy guardando",
      "Ré-essayer" : "Inténtalo de nuevo",

      "Je sauvegarde votre oeuvre d'art" : "Estoy guardando tu obra de arte",
  
      "La sauvegarde a échouée !" : "¡La copia de seguridad ha fallado!",
      "Veuillez ré-essayer.<br>Sinon <a href='/contact' target='_blank'>contacter le service client</a>" : " Inténtelo de nuevo o póngase en contacto con nuestro <a href='/contacto/' target='_blank'>servicio de atención al cliente</a>.",
  
      "Je prépare votre création" : "Estoy cargando tus fotos",
      "Ça va être génial !" : "¡Será divertido!",

      "On va créer quelque chose de beau" : "Vamos a crear algo bonito",
      "Je m'occupe de tout" : "Yo me encargo de todo",
      "Ce sera parfait !" : "¡Quedará perfecto!",
      "Ça arrive tout de suite" : "Llega enseguida",
      "Je mets tout en place" : "Estoy colocando todo en su sitio",
      "Vous êtes entre de bonnes mains" : "Estás en buenas manos",
      "Encore un petit instant..." : "Solo un momento...",
      "C'est bientôt prêt" : "Ya casi está listo",
      "J'ouvre votre création" : "Estoy abriendo tu creación",
      "On reprend votre création" : "Retomamos tu creación",
      "Je charge votre création" : "Estoy cargando tu creación",
      "Vous allez pouvoir continuer" : "Vas a poder continuar",
      "Bon retour !" : "¡Hola de nuevo!",
  
      "Votre album sera bientôt accessible" : "Tu libro estará disponible en breve",
      "Il est en cours d'envoi vers nos imprimantes." : "Se está enviando a nuestras imprentas.",
  
      
  
      "Revenir" : "Volver",
      "Quel type de couverture<br>désirez-vous ?" : "¿Qué tipo de tapa te gustaría?",
  
      "Carnet Agrafé" : "Cuaderno grapado",
      "Album Spirale" : "Álbum espiralado",
      "Album Souple" : "Álbum de tapa blanda",
      "Album Rigide" : "Álbum de tapa dura",
      "Album Ouverture à plat" : "Álbum apertura 180º",

      "Petit carré" : "Cuadrado pequeño",
      "Grand carré" : "Cuadrado grande",
      "Petit Paysage" : "Paisaje pequeño",
      "Grand Paysage" : "Paisaje grande",
      "Petit Portrait" : "Retrato pequeño",
      "Grand Portrait" : "Retrato grande",

      "21 x 21 cm" : "21 x 21 cm",
      "30 x 30 cm" : "30 x 30 cm",
      "21 x 15 cm" : "21 x 15 cm",
      "29,7 x 21 cm" : "29,7 x 21 cm",
      "15 x 21 cm" : "15 x 21 cm",
      "21 x 29,7 cm" : "21 x 29,7 cm",

      "Votre album contient $ pages" : "Tu álbum contiene $ páginas",
      "dont $ pages additionnelles (+$ €)" : "incluyendo $ páginas adicionales (+$ €)",
      "Changer la couverture" : "Cambiar la cubierta",
      "Changer la taille" : "Cambiar el tamaño",

      "A partir de $ €" : "Desde $ €",
      "A partir de <strong>$€</strong>" :  "Desde <strong>$€</strong>",
  
      "Quel type d'ouverture souhaitez-vous ?" : "¿Desea un álbum Layflat?",
      "Ouverture normale" : "Apertura normal",
      "Ouverture à plat" : "Layflat",
      "Choisissez la forme de votre album" : "Elija la forma de tu libro",
  
  
      "Retour" : "Volver",
      "Pages" : "Páginas",
      "Nombre de photos insuffisant" : "Número insuficiente de imágenes",
      "Cliquez sur Retour, et ajoutez au moins $ photo(s) pour continuer la création de votre album." : "Haz clic en Atrás, y añade fotos de $ para seguir creando tu álbum.",

      "Ajoutez des photos": "Añadir fotos",
      "photo": "foto",

     "Fermer" : "Cerrar",
     "Sauver" : "Guardar",
     "Annuler" : "Cancelar",
     "Quitter" : "Salir",

     "Cadrer" : "Recortar",
     "Par défaut" : "Por defecto",

     "Etes-vous sûre ?" : "¿Estás seguro?",
     "Cette photo est utilisée dans votre album.<br>Elle sera supprimée de toutes les pages ou elle apparaît." : "Esta foto se utiliza en tu álbum.<br>Se eliminará de todas las páginas en las que aparezca.",
     
     "Je la supprime" : "La borro",
     "Non" : "No",
 
     "En supprimant ce thème, toutes les mises en pages liées seront supprimées définitivement, et les clients n'y auront plus accès immédiatement." : "Al eliminar este tema, todos los diseños vinculados se borrarán de forma permanente, y los clientes ya no tendrán acceso a ellos inmediatamente.",
     "Je le supprime" : "Lo borro",
     
     "Votre fichier est en cours d'import..." : "Tu archivo se está importando...",
     
     "Envoyer d'autres photos" : "Envíe más fotos",
     "Je n'ai pas réussi à récupérer vos photos" : "No pude recuperar tus fotos",
     "Un problème technique est survenu. Veuillez essayer de nouveau dans quelques instants." : "Se occurio un problema técnico. Por favor, inténtelo de nuevo en unos momentos.",
     "Mémoire insuffisante" : "Memoria insuficiente",
     "Votre navigateur rencontre un problème de mémoire insuffisante. Veuillez le redémarrer pour régler le problème." : "Tu navegador está experimentando un problema de memoria insuficiente. Por favor, reinícielo para solucionar el problema.",
     "Ajout de vos photos..." : "Añadiendo tus fotos...",
     "Import de vos photos ($)" : "Importando tus fotos ($)",
     "Un fichier est déjà en cours d'import" : "Ya se está importando un archivo",
     "Veuillez attendre que le premier fichier soit importé." : "Espere a que se importe el primer archivo.",
     "Je n'ai pas pu convertir votre fichier" : "No he podido convertir tu archivo",
     "J'ai rencontré un problème en essayant de convertir votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Se occurio un problema al intentar convertir tu archivo. Inténtelo de nuevo o póngase en contacto con nuestro <a href='/contacto/' target='_blank'>servicio de atención al cliente</a>.",
     "Ces fichiers n'ont pu être transférées" : "Estos archivos no se han podido transferir",
     "Vérifiez votre connexion Internet (signal wifi faible, cable déconnecté, téléchargements en cours...), ou assurez-vous que votre fichier est encore accessible (fichier supprimé, ou disque externe déconnecté)." :  "Controla tu conexión a Internet (señal wifi débil, cable desconectado, descargas en curso...), o asegúrate de que tu archivo sigue siendo accesible (archivo borrado, o disco externo desconectado).",
     
     
     "Plus tard" : "Más tarde",
     "Votre fichier est en cours d'import" : "Tu archivo se está importando",
     "Je vous préviens dès que votre fichier est prêt à être utilisé." : "Te avisaramos en cuanto tu archivo esté listo para ser utilizado.",
     "Un problème est survenu" : "Se occurio un problema",
     "Je n'ai pas pu importer votre fichier. Veuillez ré-essayer ou contacter le <a href='/contact' target='_blank'>service client</a>." :  "Je n'ai pas pu importer votre fichier. Inténtelo de nuevo o póngase en contacto con nuestro <a href='/contacto/' target='_blank'>servicio de atención al cliente</a>.",
     "Je n'ai pas pu récupérer vos photos" : "No pude conseguir tus fotos",
     "Un problème problème technique est arrivé, vos photos n'ont pu être récupérées. Veuillez-ré-essayer ou <a href='/contact' target='_blank'>contacter notre service client</a>." :  "Se ha producido un problema técnico, no se han podido recuperar tus fotos. Por favor, inténtelo de nuevo o póngase en contacto con nuestro <a href='/contacto/' target='_blank'>servicio de atención al cliente</a>.",
     "Analyse de vos photos" : "Análisis de sus fotos",
     "Recherche des moments clés" : "Búsqueda de momentos importantes",
     "Création de votre album" : "Creación de tu álbum",
     "Votre album est prêt !" : "¡Su álbum está listo!",
     "Je n'arrive pas à récupérer votre ouvrage" : "No puedo recuperar su creación",
     "J'ai rencontré un problème en essayant de récupérer votre ouvrage. Veuillez-ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." :  "Encontré un problema al intentar recuperar su creación. Por favor, inténtelo de nuevo o <a href='/contacto' target='_blank'>contacte con nuestro servicio de atención al cliente</a>.",
     "Je n'ai pas pu charger les pages de votre fichier" : "No he podido cargar las páginas de tu archivo",
     "J'ai rencontré un problème en essayant de charger les pages de votre fichier. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "Tuve un problema al intentar cargar las páginas de tu archivo. Por favor, inténtelo de nuevo o póngase en contacto con nuestro <a href='/contacto/' target='_blank'>servicio de atención al cliente</a>.",
     "Je n'ai pas pu charger cette mise en page" : "No he podido cargar este diseño",
     "J'ai rencontré un problème en essayant de charger cette mise en page. Veuillez ré-essayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "He encontrado un problema al intentar cargar este diseño. Por favor, inténtelo de nuevo o póngase en contacto con nuestro <a href='/contacto/' target='_blank'>servicio de atención al cliente</a>.",
 
     "Votre album a été ouvert ailleurs" : "Tu álbum esta abierto en otro lugar",
     "Pour éviter des problèmes de sauvegarde, veuillez garder l'album ouvert dans une page seulement." : "Para evitar problemas de copia de seguridad, mantén el álbum abierto en una sola página.",
     
     "Une petite astuce ?" : "¿Un pequeño consejo?",
     "Pour sélectionner toutes les photos d'un répertoire, pressez en même temps les touches <strong>$ et A</strong>." : "Para seleccionar todas las fotos de una carpeta, pulsa la tecla <strong>$ y A</strong>.",
     "Ok, c'est parti !" : "Bien, ¡allá vamos!",
 
     "Un problème avec votre connexion Internet ?" : "¿Problemas de conexión a Internet?",
     "Notre application n'arrive pas à se connecter à nos serveurs pour sauvegarder votre travail." : "Nuestra aplicación no puede conectarse a nuestros servidores para guardar tu trabajo.",
     "Tentative de reconnexion..." : "Intentando reconectar...",
 
     "Ne perdez pas votre travail." : "No pierdas tu trabajo.",
     "Sauvegardez votre travail, c'est simple et gratuit!<br><br>Votre création sera conservé sans limite de temps, et vous pourrez continuer à la modifier quand vous le souhaitez." : "¡Guarda tu trabajo, es simple y gratuito!<br><br>Tu creación se conservará sin límite de tiempo y podrás seguir editándola cuando quieras.",
 
     "Connectez-vous" : "Conectarse",
     "Votre email" : "Tu correo electrónico",
     "Votre mot de passe" : "Tu contraseña",
     "Vous ne possedez pas encore de compte ?" : "¿Aún no tiene cuenta?",
     "Se connecter" : "Conectarse",
     "Le format de votre email est incorrect" : "Formato de correo electrónico incorrecto",
     "Votre mot de passe doit contenir au moins 6 caractères" : "Tu contraseña debe contener al menos 6 caracteres",
     "Veuillez saisir votre email et mot de passe" : "Introduzca tu correo electrónico y contraseña",
     "Connexion" : "Conectarse",
     "Email ou mot de passe incorrect" : "Correo electrónico o contraseña incorrectos",
     "Email déjà utilisé" : "Correo electrónico ya utilizado",
     "Enregistrement" : "Regístrese",
     "Mot de passe incorrect" : "Contraseña incorrecto",
 
     "Bienvenue chez Flexilivre !" : "¡Bienvenido a Flexilivre !",
     "Créez votre album en toute tranquillité, il est sauvegardé automatiquement sur votre compte." : "Cree tu álbum con toda tranquilidad, se guardará automáticamente en tu cuenta.",
 
     "Sauvegarder votre ouvrage" : "Guarda tu libro",
     "Entrez votre email" : "Introduzca tu dirección de correo electrónico",
     "Choisissez votre mot de passe" : "Elija tu contraseña",
     "Vous possedez deja un compte?" : "¿Ya tienes una cuenta?",
     "En poursuivant, vous acceptez lez conditions generales" : "Al hacer clic, confirmas aceptar nuestras menciones legales",
 
     "Ajout impossible" : "Añadiendo imposible",
     "Votre album photo ne peut contenir plus de $ pages." : "Tu libro no puede contener más de $ páginas.",
     "Suppression impossible" : "Quitar imposibles",
     "Votre album photo ne peut contenir moins de $ pages." : "Tu libro no puede contener menos de $ páginas.",
     
     "Je n'arrive pas à sauvegarder votre création" : "No puedo guardar tu creación",
     "J'ai rencontré un problème lors de la sauvegarde de votre création. Veuillez-ressayer, ou <a href='/contact' target='_blank'>contacter notre service client</a>." : "He encontrado un problema al guardar su creación. Por favor, inténtelo de nuevo o <a href='/contact' target='_blank'>contacte con nuestro servicio de atención al cliente</a>.",
     
     "Une erreur est arrivée" : "Se occurio un error",
     "Nous n'avons pu joindre le serveur. Veuillez ré-essayer de nouveau, ou contacter <a href='/contact/' target='_blank'>notre service technique</a>" : "No hemos podido contactar con el servidor. Por favor, inténtelo de nuevo o póngase en contacto con nuestro <a href='/contacto/' target='_blank'>servicio de atención al cliente</a>.",
 
     "Texte de la tranche de l'album" : "Texto de la portada del álbum",
     "Texte" : "Texto", 
     "Fond" : "Fondo",
     "Retourner" : "Voltear",
     "Tourner" : "Voltear",
     "Supprimer" : "Eliminar",
     "Supprimer ces 2 pages" : "Eliminar esas 2 páginas",

     /* theme edit */
     "Sélectionnez la thématique" : "Escoge una temática",
     "Choisir ces modèles" : "Elegir estos modelos",
     "Tous les modèles" : "Todos los modelos",
     "Sélectionnez un thème" : "Selecciona un tema",
 
     "Ouverture impossible" : "No se puede abrir",
     "L'application d'édition ne peut être ouverte que depuis notre site" : "La aplicación de edición sólo puede abrirse desde nuestro sitio web",
     "Retourner sur Flexilivre.com" : "Ir a Flexilivre.com",
 
     
     // renderers
     "Photo utilisée" : "Foto utilizada",
     "Photo sélectionnée" : "Foto seleccionada",
 
     // social
     "Si rien ne ne se passe après avoir cliqué sur le bouton ci-dessus, veuillez autoriser votre navigateur à afficher les popups." : "Si no ocurre nada después de hacer clic en el botón anterior, permita que tu navegador muestre ventanas emergentes.",
     "Cliquez sur le bouton ci-dessous pour vous connectez et autoriser notre application à importer vos photos." : "Haz clic en el botón de abajo para iniciar sesión y permitir que nuestra aplicación importe tus fotos.",
 
     //stage
     "Cette image n'a pu être chargée" : "Esta foto no se puede cargar",
     "Ne placez pas visages au niveau de la séparation des pages,<br>ils risquent de ne pas se recouper parfaitement après la fabrication." : "No coloques las caras en la separación de páginas, ya que podrían no visualizarse perfectamente después de la fabricación.",
     "Votre photo n'est pas de qualité suffisante. Réduisez sa taille, ou remplacez-la par une meilleure photo." : "Tu foto no tiene suficiente calidad. Reduce su tamaño o sustitúyela por una foto mejor.",
     "Cliquez pour personnaliser la tranche" : "Pincha aquí para personalizar la portada",
     "L'ajout de texte sur la tranche n'est possible qu'avec une couverture rigide, ou avec plus de 40 pages." : "Añadir texto en la tapa sólo es posible con tapa dura o con más de 40 páginas.",
     "Ce bloc texte est trop proche du bord. Déplacez-le ou réduisez-le pour qu'il ne soit pas coupé lors de la fabrication." : "Este texto está demasiado cerca del borde. Desplázalo o redúcelo para que no se corte durante la producción.",

     "Votre texte dépasse !" : "¡Tu texto es demasiado largo!",
     "Votre texte est trop proche du bord de la page, il risque de ne pas être imprimé totalement." : "Tu texto sale del marco de la página, lo que podría resultar en una impresión incompleta.",
     "Déplacez votre texte, ou réduisez-le." : "Mueva tu texto o réduzcalo.",
 
     "Ajouter deux pages" : "Añadir dos páginas",
     "Chargement" : "Cargando",
     "Modifier la couleur de fond" : "Modificar color de fondo",
     "Ajouter du texte" : "Añadir texto",
     "Le logo est supprimable au moment du passage de la commande.<br><br>Par contre, le QRCode n'est pas supprimable." : "El logotipo se puede eliminar al pedir el libro.<br>El código QR no se puede eliminar.",
 
     // data / filters
     "Recherche" : "Búsqueda",
     "Fonds utilisés" : "Fondos utilizados",
     "Fonds recommandés" : "Fondos recomendados",
     "Stickers utilisés" : "Pegatinas utilizadas",
     "Stickers recommandés" : "Pegatinas recomendadas", 
     "Aucun résultat pour" : "Ningún resultado para",
     "Pages simples" : "Páginas individuales",
     "Pages doubles" : "Página doble",
     "Normal" : "Sin efecto",
     "Lumière" : "Luminosidad",
     "Contraste" : "Contraste",
     "Couleur +" : "Colorido",
     "Netteté" : "Limpio",
     "Vieilli" : "Antiguo",
     "Noir & Blanc" : "Blanco y negro",
     "Sepia" : "Sepia",
     "Focus" : "Focus",
     "Vintage" : "Vintage",
     "Vintage 2" : "Vintage 2",
     "Ordre d'ajout" : "Orden de adición",
     "Ordre Chronologique" : "Ordenación cronológica",
     "Par visage" : "per cara",
 
     // data / models
     "Cliquez pour personnaliser la tranche" : "Pincha aquí para personalizar el texto de la portada",
     "L'ajout de texte sur la tranche n'est possible que si votre album contient au moins 40 pages" : "Añadir texto en la portada sólo es posible si tu álbum contiene al menos 40 páginas",
     "L'ajout de texte sur la tranche n'est possible que : <ul><li>Sur une couverture rigide</li><li>Sur une couverture souple avec au moins 40 pages</li></ul>" : "Añadir texto en la tapa sólo es posible : <ul><li>En tapa dura</li><li>En una tapa blanda de al menos 40 páginas</li></ul>", 
     "Couverture Agrafée" : "Tapa grapada",
     "Couverture Spirale" : "Tapa espiral",
     "Couverture Souple" : "Tapa blanda",
     "Couverture Rigide" : "Tapa dura",
     "Rigide & Ouverture à plat" : "Tapa dura LayFlat",
     "Couverture Dos" : "Cubierta trasera",
     "Couverture Face" : "Tapa delantera",
     "Couv." : "Cub.",
     "Couverture" : "Tapa",
     "Ajouter un texte" : "Añadir un texto",
     "Ajouter un TITRE" : "Añadir un TÍTULO",
     "Page" : "Página",
     "page" : "página",


     "- La " : "- ",
     "est vide" : "esta vacía",
 
     // data / repositories
     "Rectangle" : "Rectángulo",
     "Triangle" : "Triángulo",
     "Losange" : "Diamante",
     "Etoile" : "Estrella",
     "Cercle" : "Círculo",
     "Coeur" : "Corazón",
     "Polygone" : "Polígono",
     
     // --- new
     // photo renderer
     "Veuillez attendre la fin du transfer<br>pour pouvoir utiliser cette photo." : "Espera a que se complete la transferencia <br>antes de utilizar esta foto.",
     "Intérieur de couverture<br> non imprimable" : "Interior de la tapa<br> no imprimible",
     "Votre fichier a été importé !" : "Tu archivo ha sido importado",
     "Nous avons converti votre fichier en album. Veuillez vérifier qu'aucun texte important ne soit trop proche des bords. Il risquerai d'être coupé à la fabrication." : "Hemos convertido tu archivo en un álbum. Asegúrate de que ningún <a href='/ayuda/sangria/' target='_blank'>texto importante esté demasiado cerca de los bordes.</a> Podría cortarse durante la producción.",
 
     "Appliquer" : "Aplique",

     "Appliquer à la page courante" : "Aplicar a la página actual",
     "Appliquer à toutes les pages" : "Aplicar a todas las páginas",
     "Vos mises en page" : "Tus diseños",
	
     "Votre album ne contient pas un nombre de pages multiple de 4." : "Tu álbum no contiene un número de páginas que sea múltiplo de 4.",
     "Par ailleurs, votre album ne contient pas un nombre de pages multiple de 4." : "Además, tu álbum no contiene un número de páginas que sea múltiplo de 4.",
     "Une feuille sera donc ajoutée à la fin de votre ouvrage au moment de la fabrication." : "Se añadirá una hoja al final de su obra en el momento de la fabricación",

     "Je vérifie votre création.." : "Reviso tu creación..",
     "C'est parti !" : "¡VAMOS!",

     "C'est parfait !" : "¡Es perfecto!",
     "Nous attendons la réception de vos photos pour continuer.<br/> Vous serez redirigé automatiquement." : "Estamos esperando recibir tus fotos para continuar.<br/> Serás redirigido automáticamente.",

     "Ajouter une photo" : "Añadir una foto",
     "Déposez votre photo ici" : "Coloca tu foto aquí",

     "Choisissez la taille de votre album" : "Escoge el tamaño de tu álbum",
     "Prix : <strong>$ €</strong>" : "Precio: <strong>$ €</strong>",
     "Top Vente" : "Más vendido",
     "Souhaitez-vous un format plus grand ?" : "¿Deseas un formato más grande?",
     "Souhaitez-vous sublimer votre album ?" : "¿Deseas realzar tu álbum?",
     "Sélectionnez la couverture de votre album" : "Selecciona la portada de tu álbum",
     "Album Rigide + Ouverture à plat" : "Álbum Rígido + Apertura plana",
     "Indisponible<br>avec la couverture actuelle" : "No disponible<br>con la tapa actual",
     "Non disponible à cause du nombre de pages de votre album" : "No disponible debido al número de páginas de tu álbum",

     "Ajoutez vos photos" : "Agrega tus fotos",
     "Sélectionnez vos photos" : "Selecciona tus fotos",

     "Sélectionnez au minimum 24 photos" : "Seleccione al menos 24 fotos",

     "Je peux créer votre album pour vous !" : "¡Puedo crear tu álbum por ti!",
     "Oui, c'est parti !" : "¡Sí, allá vamos!",
     "Je vais vous créer un magnifique album !" : "¡Crearé un álbum precioso para ti!",
     "C'est parti" : "Vamos",
     "Je créé votre album, ca sera rapide !" : "Creo tu álbum, ¡será rápido!",
     "Votre album est prêt !" : "Tu álbum está listo",
 
     "Retourner à votre album" : "Volver a tu álbum",
     "J'analyse vos photos" : "Estoy analizando tus fotos",
     "J'analyse vos photos ($%)" : "Estoy analizando tus fotos ($%)",
     "Quel titre pour votre album ?" : "¿Qué título para tu álbum?",
     
     "Choisissez une proposition ou saisissez le vôtre." : "Elige una propuesta o escribe la tuya.",
     
     "Le titre de votre album" : "El título de tu álbum",
     
     "Je cherche des idées de titre..." : "Buscando ideas de título...",
     
     "Créer mon album" : "Crear mi álbum",
     
     "Le $" : "El $",
     "Début $" : "Principios de $",
     
     "Été $" : "Verano $",
     
     "Fin $" : "Finales de $",
     
     "Année $" : "Año $",
     "Souhaitez-vous que je crée votre album photo ?" : "¿Quieres que cree tu álbum de fotos?",
     "Composition intelligente" : "Composición inteligente",
     "Je crée votre album pour vous !" : "¡Creo su álbum por usted!",
     "Vos photos rangées par date, posées sur des pages équilibrées. Vous n'avez plus qu'à relire." : "Sus fotos ordenadas por fecha, colocadas en páginas equilibradas. Solo le queda repasarlo.",
     "Ordre chronologique respecté" : "Orden cronológico respetado",
     "Chaque page modifiable" : "Todas las páginas modificables",
     "Prêt en quelques secondes" : "Listo en unos segundos",
     "Composer mon album" : "Componer mi álbum",
     "Non merci" : "No, gracias",
     "Le contenu de votre album va être remplacé" : "El contenido de su álbum será reemplazado",
     
     "Vos photos seront placées par ordre chronologique,<br>et vous n'aurez plus qu'à vérifier votre album." : "Tus fotos se colocarán en orden cronológico,<br>solo tendrás que revisar tu álbum.",
     
     "Attention : votre contenu sera totalement remplacé." : "Atención: tu contenido será reemplazado por completo.",
     
     "Oui, Créez mon album" : "Sí, crea mi álbum",
     
     "Non, merci" : "No, gracias",
     
     "Je récupère vos photos" : "Recupero tus fotos",
     "© $" : "© $",
     "du $ au $" : "del $ al $",
     "du $ au $ $" : "del $ al $ de $",
     "Une fin d'année réunis" : "Juntos a fin de año",
     "Un week-end en images" : "Un fin de semana en imágenes",
     "Nos bons moments" : "Nuestros buenos momentos",
     "Le livre de recettes" : "El libro de recetas",
     "Nos recettes de famille" : "Nuestras recetas familiares",
     "Mes recettes" : "Mis recetas",
     "Moment de famille" : "Momento en familia",
     "Réunion de famille" : "Reunión familiar",
     "Fête de famille" : "Fiesta familiar",
     "Nos compagnons" : "Nuestros compañeros",
     "Mon compagnon" : "Mi compañero",
     "Mon animal" : "Mi mascota",
     "Nous deux" : "Nosotros dos",
     "Toi et moi" : "Tú y yo",
     "Notre histoire" : "Nuestra historia",
     "Nos premiers moments" : "Nuestros primeros momentos",
     "Bienvenue au monde" : "Bienvenido al mundo",
     "Notre petit ange" : "Nuestro angelito",
     "Souvenirs de voyage" : "Recuerdos de viaje",
     "Carnet de voyage" : "Cuaderno de viaje",
     "Oui pour la vie" : "Sí para toda la vida",
     "Notre plus beau jour" : "Nuestro día más bonito",
     "Notre Mariage" : "Nuestra boda",
     "Joyeux anniversaire" : "Feliz cumpleaños",
     "Mon anniversaire" : "Mi cumpleaños",
     "Une année de plus" : "Un año más",
     "Notre soirée" : "Nuestra noche",
     "Entre amis" : "Entre amigos",
     "C'était la fête" : "Menuda fiesta",
     "Notre voyage" : "Nuestro viaje",
     "J'affine mes propositions ..." : "Estoy afinando mis propuestas ...",
     "On feuillette vos $ photos…" : "Estoy hojeando tus $ fotos…",
     "On repère les moments forts…" : "Busco los mejores momentos…",
     "On imagine 3 titres…" : "Imagino 3 títulos…",
     "C'est plus long que prévu, on y est presque…" : "Está tardando más de lo previsto, ya casi está…",
     "Un instant, je place vos photos..." : "Un momento, estoy colocando tus fotos...",
     "Week-end à $" : "Fin de semana en $",
     
     "Un saut à $" : "Una escapada a $",
     
     "Escapade à $" : "Escapada a $",
     
     "Une journée à $" : "Un día en $",
     
     "Une semaine à $" : "Una semana en $",
     
     "À la découverte de $" : "Descubriendo $",
     
     "Nos vacances à $" : "Nuestras vacaciones en $",
     
     "Un voyage à $" : "Un viaje a $",
     
     "Les vacances de Noël à $" : "Las vacaciones de Navidad en $",
     
     "La fin d'année à $" : "Fin de año en $",
     
     "Un été à $" : "Un verano en $",
     
     "Notre week-end : $" : "Nuestro fin de semana: $",
     
     "Nos vacances : $" : "Nuestras vacaciones: $",
     
     "Souvenirs : $" : "Recuerdos: $",
     
     "Découverte : $" : "Descubriendo $",
     
     "Noël : $" : "Navidad: $",
     
     "Les fêtes : $" : "Las fiestas: $",
     
     "Un été : $" : "Un verano: $",
     
     "Noël $" : "Navidad $",
     
     "Les fêtes de fin d'année" : "Las fiestas de fin de año",
     
     "Notre week-end" : "Nuestro fin de semana",
     
     "Un week-end en famille" : "Un fin de semana en familia",
     
     "Nos vacances" : "Nuestras vacaciones",
     
     "Souvenirs de vacances" : "Recuerdos de vacaciones",
     
     "L'été $" : "El verano de $",
     
     "Nos souvenirs de $" : "Nuestros recuerdos de $",
     
     "Nos plus beaux moments" : "Nuestros mejores momentos",
     "Un mobile" : "Un móvil",
     "Votre ordinateur" : "Tu ordenador",
     "Réseaux sociaux" : "Redes sociales",
     "Autre" : "Otro",
     "Facebook" : "Facebook",
     "Instagram" : "Instagram",
     "Google" : "Google",
     "Fichier PDF" : "Archivo PDF",
     "Vos Albums" : "Tus álbumes",

     "Connecté à Google Photos sur " : "Conectado a Google Fotos en ",
     "Se déconnecter" : "Desconectarse",

      //  edition
      "Zoom -" : "Zoom -",
      "Zoom +" : "Zoom +",
      "Rotation" : "Rotación",
      "Bord" : "Borde",
      "Forme" : "Forma",
      "Effet" : "Efectos",
      "Descendre" : "Atrás",
      "Remonter" : "Al frente",
      
      
      "Inverser" : "Invertir",
      "Gras" : "Negrita",
      "Italic" : "Cursiva",
      "Fond" : "Fondo",
      "Gauche" : "Izquierda",
      "Centre" : "Centro",
      "Droite" : "Derecha",

      "Les détails de votre album" : "Detalles de tu álbum",
      "J'ai compris" : "Si, Comprendo",

      "Le format de fichier que vous avez sélectionné est incorrect." : "El formato de archivo que has seleccionado es incorrecto.",
      "Veuillez choisir un fichier avec une extension valide (.pdf)" : "Por favor, elija un archivo con una extensión válida (.pdf)",
  
     "De $ à $ pages" : "Desde $ hasta $ páginas",
     "Album $, $" : "Álbum $, $",
     "Pages" : "Páginas",
     "A partir de $" : "Desde $",

     "Refaire" : "Rehacer",
    
     "Bravo !": "bien hecho",
     "Erreur !": "error",
     "Vos photos ont bien été envoyées" : "Tus fotos han sido enviadas exitosamente",
     "Vos photos n'ont pas pu être téléchargées" : "Tus fotos no se pudieron cargar",
     "Téléchargement en cours" : "Descargando",
     "Gardez la fenêtre de votre navigateur ouverte pendant le chargement de vos photos": "Mantén abierta la ventana de tu navegador mientras se cargan tus fotos",
     "Bienvenue" : "Bienvenido",
     "Envoyer des photos" : "Enviar fotos",
     
     "Ajouter des photos" : "Añadir fotos",
     
     "Veuillez ajouter au moins $ photos" : "Añada al menos $ fotos",

     "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "Debe tener al menos <span class='numPhotosLabel'>$ fotos</span> para ordenar sus impresiones",
     "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander vos tirages" : "Debe tener menos de <span class='numPhotosLabel'>$ fotos</span> para ordenar sus impresiones",

     "Vous devez avoir au moins <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "Debe tener al menos <span class='numPhotosLabel'>$ fotos</span> para pedir su álbum",
     "Vous devez avoir moins de <span class='numPhotosLabel'>$ photos</span> pour commander votre album" : "Debe tener menos de <span class='numPhotosLabel'>$ fotos</span> para pedir su álbum",

     "Trier / filtrer vos photos" : "Ordenar / filtrar tus fotos",
     "Ajoutez des photos puis cliquez ici pour les placer automatiquement" : "Añade fotos y haz clic aquí para colocarlas automáticamente",
     "<b>$</b> vous a envoyé": "<b>$</b> le ha enviado",
     "Refuser": "Rechazar",
     "Voir les photos": "Ver las fotos",
     "Vous allez perdre les photos partagées de $.": "Vas a perder las fotos compartidas de $.",
     "Êtes vous sûr de vouloir quitter?": "¿Estás seguro de que quieres salir?",
     "Vous allez perdre les photos partagées de $. Êtes vous sûr de vouloir quitter?": "Vas a perder las fotos compartidas de $. ¿Estás seguro de que quieres salir?",
     "Sélectionnez les photos que vous souhaitez garder": "Selecciona las fotos que deseas conservar",
     "Tout sélectionner ($)": "Seleccionar todo ($)",
     "Tout déselectionner ($)": "Deseleccionar todo ($)",
     "Valider ($)": "Validar ($)",
     "Importer ($)": "Importar ($)",
     "Choisissez vos photos dans la fenêtre Google. Elles arriveront ici.": "Elige tus fotos en la ventana de Google. Aparecerán aquí.",
     "Vos photos": "Tus fotos",
     "$ photos reçues": "$ fotos recibidas",
     "$ sur $ photos reçues": "$ de $ fotos recibidas",
     "Vos photos arrivent": "Tus fotos están llegando",
     "Envoyez vos photos depuis votre mobile": "Envía tus fotos desde tu móvil",
     "Ouvrez le lien reçu par SMS et choisissez vos photos.": "Abre el enlace recibido por SMS y elige tus fotos.",
     "En attente du téléphone": "Esperando el teléfono",
     "Nous attendons vos photos…": "Esperando tus fotos…",
     "Gardez cette page ouverte. Les photos apparaîtront ici dès leur arrivée.": "Mantén esta página abierta. Tus fotos aparecerán aquí a medida que lleguen.",
     "Aucune photo reçue": "Ninguna foto recibida",
     "Continuez l'envoi depuis votre mobile, la liste se met à jour toute seule.": "Sigue enviando desde tu móvil, la lista se actualiza sola.",
     "Réception en cours": "Recibiendo",
     "Vos photos sont prêtes": "Tus fotos están listas",
     "Importez-les dans votre album pour commencer la mise en page.": "Impórtalas a tu álbum para empezar la maquetación.",
     "$ photos seront ajoutées à votre album": "$ fotos se añadirán a tu álbum",
     "Envoi pas encore terminé": "El envío aún no ha terminado",
     "Vos photos arrivent encore depuis votre mobile. Importer seulement les $ photos déjà reçues ?": "Tus fotos siguen llegando desde tu móvil. ¿Importar solo las $ ya recibidas?",
     "Importer $ photos": "Importar $ fotos",
     "Continuer l'attente": "Seguir esperando",


     // Google Photos import (SelectPhotosPanel)
     "Importez-les pour les ajouter à votre création.": "Impórtalas para añadirlas a tu creación.",
     "$ photos seront importées": "se importarán $ fotos",
     "Aucune photo n'a été reçue.": "No se ha recibido ninguna foto.",
     "Aucune photo n'a pu être récupérée.": "No se ha podido recuperar ninguna foto.",
     "Récupération de vos photos Google": "Recuperando tus fotos de Google",
     "Nous les récupérons depuis Google Photos, cela peut prendre un moment.": "Las estamos recuperando de Google Fotos, puede tardar un momento.",
     "Connexion à Google Photos": "Conectando con Google Fotos",
     "Nous récupérons vos photos…": "Recuperando tus fotos…",
     "Elles sont récupérées depuis Google Photos, la liste se met à jour toute seule.": "Se están recuperando de Google Fotos, la lista se actualiza sola.",
     "Récupération en cours": "Recuperación en curso",
     "Récupération pas encore terminée": "La recuperación aún no ha terminado",
     "La récupération des photos depuis Google n'est pas terminée. Souhaitez-vous importer seulement les $ photos affichées ?": "Todavía estamos recuperando tus fotos de Google. ¿Importar solo las $ que se muestran?",

     "Cliquez pour changer la taille ou la couverture" : "Pincha aquí para cambiar el tamaño o la tapa",
     "Cliquez pour changer la taille de votre cadre": "Haga clic para cambiar el tamaño de su marco",
     "Cliquez pour changer la taille de votre affiche": "Haga clic para cambiar el tamaño de su póster",
     "Cliquez pour changer la taille" : "Haz clic para cambiar el tamaño",
     "contient une zone photo vide" : "contiene un área de foto vacía",
     "contient $ zones photo vides" : "contiene $ áreas de foto vacía",

     "Transparence" : "Transparencia",

     "Vous devez ajouter au moins 24 photos" : "Tienes que añadir al menos 24 fotos",

     "Quel type d'album souhaitez-vous créer ?" : "¿Qué tipo de álbum te gustaría crear?",
     "Choisissez le thème de votre album" : "Elige el tema de tu álbum",
     "Type d'album" : "Tipo de álbum",

     "Budget" : "Presupuesto",
     "Thèmes" : "Temas",
     "Votre Album" : "Tu álbum",

     "Cliquez ici pour agrandir" : "Pincha aquí para ampliar",

       //----
    "Bienvenue dans votre album" : "Bienvenido a tu álbum",
    
    "Voici quelques informations rapides<br>avant de commencer" : "Aquí algunas explicaciones rápidas<br>antes de empezar",
    "L'effet 3D sera appliqué lors de l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas l'effet 3D dans l'éditeur</span>" : "El efecto 3D sólo se aplicará al imprimir el libro. Con el libro se incluyen :<br><br>2 pares de gafas 3D.<br><br><span class='blue bold'>No verás el efecto<br>3D directamente en la pantalla.</span>",
    "L'effet 3D sera appliqué lors de<br>l'impression de votre album.<br><br>2 paires de lunettes 3D<br>seront incluses dans votre colis.<br><br><span class='blue bold'>Vous ne verrez pas<br>l'effet 3D dans l'éditeur</span>" : "El efecto 3D sólo se aplicará al<br>imprimir el libro.<br><br>Con el libro se incluyen<br>2 pares de gafas 3D.<br><br><span class='blue bold'>No verás el efecto<br>3D directamente en la pantalla.</span>",
    "Choisissez bien vos photos, pour un <span class='green'>effet optimal</span>" : "Escoge correctamente tus imágenes, para un perfecto <span class='green'>efecto 3D</span>.",
    "Choisissez bien vos photos<br>pour un <span class='green'>effet optimal</span>" : "Escoge correctamente tus imágenes<br>para un perfecto <span class='green'>efecto 3D</span>.",
    "Arrière plan avec de la matière<br>et une profondeur raisonnable" : "Fondo con material<br> y suficiente profundidad",
    "Sujet au<br>premier plan" : "Sujeto en<br>primer plano",
    "de 1 à 4<br>personnes max" : "De 1 a 4<br>personas máximo",

    "Vue page" : "Vista por página",

    "Coller" : "Pegar",

    "Comment faire ?" : "¿Cómo hacer?",
    "Entrez votre numéro de téléphone portable. Vous recevrez un sms avec le lien de l'application. Vous pourrez alors envoyer vos photos vers votre albums." : "Introduce tu número de teléfono móvil. Recibirás un mensaje de texto con el enlace de la aplicación. Desde allí podrás enviar tus fotos a tu álbum.",
    "Téléphone" : "Teléfono",
    "numéro invalide" : "número inválido",
    "plus rapide" : "más rápido",
    "Scannez ce QRcode pour récupérer les photos depuis votre mobile" : "Scanea este QR code para recuperar las fotos desde tu móvil.",


    "Album Blanc" : "Álbum en Blanco",

    "Marge de découpe" : "Márgenes de corte",

    "Votre album est sauvegardé !" : "¡Has guardado tu álbum!",
    "A partir de maintenant, votre album est sauvegardé automatiquement." : "A partir de ahora, tu álbum se guaradá automaticámente.",

    // Ajout de pages

    "Vierges": "En blanco",
    "Thématiques": "Temáticas",
    "Ajouter des pages": "Añadir páginas",
    "jusqu'à $ pages ($€ par pages)": "hasta $ páginas ($€ por página)",
    "$ pages": "$ páginas",
    "Vous avez atteint le nombre maximum de pages": "Has alcanzado el número máximo de páginas",

    // Countries
    "Afghanistan": "Afganistán",
    "Albanie": "Albania",
    "Algérie": "Argelia",
    "Samoa Américaines": "Samoa Americana",
    "Andorre": "Andorra",
    "Angola": "Angola",
    "Anguilla": "Anguila",
    "Antarctique": "Antártida",
    "Antigua-et-Barbuda": "Antigua y Barbuda",
    "Argentine": "Argentina",
    "Arménie": "Armenia",
    "Aruba": "Aruba",
    "Australie": "Australia",
    "Autriche": "Austria",
    "Azerbaïdjan": "Azerbaiyán",
    "Bahamas": "Bahamas",
    "Bahreïn": "Bahrein",
    "Bangladesh": "Bangladesh",
    "Barbade": "Barbados",
    "Bélarus": "Bielorrusia",
    "Belgique": "Bélgica",
    "Belize": "Belice",
    "Bénin": "Benín",
    "Bermudes": "Bermudas",
    "Bhoutan": "Bután",
    "Bolivie": "Bolivia",
    "Bosnie-Herzégovine": "Bosnia y Herzegovina",
    "Botswana": "Botsuana",
    "Île Bouvet": "Isla Bouvet",
    "Brésil": "Brasil",
    "Territoire britannique de l'océan Indien": "Territorio Británico del Océano Índico",
    "Îles Vierges britanniques": "Islas Vírgenes Británicas",
    "Brunei Darussalam": "Brunéi Darussalam",
    "Bulgarie": "Bulgaria",
    "Burkina Faso": "Burkina Faso",
    "Burundi": "Burundi",
    "Cambodge": "Camboya",
    "Cameroun": "Camerún",
    "Canada": "Canadá",
    "Cap-Vert": "Cabo Verde",
    "Îles Caïmans": "Islas Caimán",
    "République centrafricaine": "República Centroafricana",
    "Tchad": "Chad",
    "Chili": "Chile",
    "Chine": "China",
    "Île Christmas": "Isla de Navidad",
    "Îles Cocos (Keeling)": "Islas Cocos (Keeling)",
    "Colombie": "Colombia",
    "Comores": "Comoras",
    "Congo": "Congo",
    "République démocratique du Congo": "República Democrática del Congo",
    "Îles Cook": "Islas Cook",
    "Costa Rica": "Costa Rica",
    "Croatie": "Croacia",
    "Cuba": "Cuba",
    "Chypre": "Chipre",
    "République tchèque": "República Checa",
    "Danemark": "Dinamarca",
    "Djibouti": "Yibuti",
    "Dominique": "Dominica",
    "République dominicaine": "República Dominicana",
    "Équateur": "Ecuador",
    "Égypte": "Egipto",
    "Salvador": "El Salvador",
    "Guinée équatoriale": "Guinea Ecuatorial",
    "Érythrée": "Eritrea",
    "Estonie": "Estonia",
    "Éthiopie": "Etiopía",
    "Îles Malouines": "Islas Malvinas",
    "Îles Féroé": "Islas Feroe",
    "Fidji": "Fiyi",
    "Finlande": "Finlandia",
    "France": "Francia",
    "Guyane française": "Guayana Francesa",
    "Polynésie française": "Polinesia Francesa",
    "Terres australes françaises": "Territorios Australes Franceses",
    "Gabon": "Gabón",
    "Gambie": "Gambia",
    "Géorgie": "Georgia",
    "Allemagne": "Alemania",
    "Ghana": "Ghana",
    "Gibraltar": "Gibraltar",
    "Grèce": "Grecia",
    "Groenland": "Groenlandia",
    "Grenade": "Granada",
    "Guadeloupe": "Guadalupe",
    "Guam": "Guam",
    "Guatemala": "Guatemala",
    "Guernesey": "Guernsey",
    "Guinée": "Guinea",
    "Guinée-Bissau": "Guinea-Bissau",
    "Guyane": "Guyana",
    "Haïti": "Haití",
    "Îles Heard-et-MacDonald": "Islas Heard y McDonald",
    "Saint-Siège (État de la Cité du Vatican)": "Santa Sede (Ciudad del Vaticano)",
    "Honduras": "Honduras",
    "Hong Kong": "Hong Kong",
    "Hongrie": "Hungría",
    "Islande": "Islandia",
    "Inde": "India",
    "Indonésie": "Indonesia",
    "Iran": "Irán",
    "Iraq": "Iraq",
    "Irlande": "Irlanda",
    "Île de Man": "Isla de Man",
    "Israël": "Israel",
    "Italie": "Italia",
    "Jamaïque": "Jamaica",
    "Japon": "Japón",
    "Jersey": "Jersey",
    "Jordanie": "Jordania",
    "Kazakhstan": "Kazajistán",
    "Kenya": "Kenia",
    "Kiribati": "Kiribati",
    "Corée du Nord": "Corea del Norte",
    "Corée du Sud": "Corea del Sur",
    "Koweït": "Kuwait",
    "Kirghizistan": "Kirguistán",
    "Laos": "Laos",
    "Lettonie": "Letonia",
    "Liban": "Líbano",
    "Lesotho": "Lesoto",
    "Libéria": "Liberia",
    "Libye": "Libia",
    "Liechtenstein": "Liechtenstein",
    "Lituanie": "Lituania",
    "Luxembourg": "Luxemburgo",
    "Macao": "Macao",
    "Macédoine du Nord": "Macedonia del Norte",
    "Madagascar": "Madagascar",
    "Malawi": "Malaui",
    "Malaisie": "Malasia",
    "Maldives": "Maldivas",
    "Mali": "Malí",
    "Malte": "Malta",
    "Îles Marshall": "Islas Marshall",
    "Martinique": "Martinica",
    "Mauritanie": "Mauritania",
    "Maurice": "Mauricio",
    "Mayotte": "Mayotte",
    "Mexique": "México",
    "Micronésie": "Micronesia",
    "Moldavie": "Moldavia",
    "Monaco": "Mónaco",
    "Mongolie": "Mongolia",
    "Monténégro": "Montenegro",
    "Montserrat": "Montserrat",
    "Maroc": "Marruecos",
    "Mozambique": "Mozambique",
    "Myanmar": "Myanmar",
    "Namibie": "Namibia",
    "Nauru": "Nauru",
    "Népal": "Nepal",
    "Pays-Bas": "Países Bajos",
    "Nouvelle-Calédonie": "Nueva Caledonia",
    "Nouvelle-Zélande": "Nueva Zelanda",
    "Nicaragua": "Nicaragua",
    "Niger": "Níger",
    "Nigeria": "Nigeria",
    "Niue": "Niue",
    "Île Norfolk": "Isla Norfolk",
    "Îles Mariannes du Nord": "Islas Marianas del Norte",
    "Norvège": "Noruega",
    "Oman": "Omán",
    "Pakistan": "Pakistán",
    "Palaos": "Palaos",
    "Palestine": "Palestina",
    "Panama": "Panamá",
    "Papouasie-Nouvelle-Guinée": "Papúa Nueva Guinea",
    "Paraguay": "Paraguay",
    "Pérou": "Perú",
    "Philippines": "Filipinas",
    "Îles Pitcairn": "Islas Pitcairn",
    "Pologne": "Polonia",
    "Portugal": "Portugal",
    "Porto Rico": "Puerto Rico",
    "Qatar": "Catar",
    "Réunion": "Reunión",
    "Roumanie": "Rumania",
    "Russie": "Rusia",
    "Rwanda": "Ruanda",
    "Saint-Barthélemy": "San Bartolomé",
    "Sainte-Hélène, Ascension et Tristan da Cunha": "Santa Elena, Ascensión y Tristán de Acuña",
    "Saint-Christophe-et-Niévès": "San Cristóbal y Nieves",
    "Sainte-Lucie": "Santa Lucía",
    "Saint-Martin (partie française)": "San Martín (parte francesa)",
    "Saint-Pierre-et-Miquelon": "San Pedro y Miquelón",
    "Saint-Vincent-et-les-Grenadines": "San Vicente y las Granadinas",
    "Samoa": "Samoa",
    "Saint-Marin": "San Marino",
    "Sao Tomé-et-Principe": "Santo Tomé y Príncipe",
    "Arabie saoudite": "Arabia Saudita",
    "Sénégal": "Senegal",
    "Serbie": "Serbia",
    "Seychelles": "Seychelles",
    "Sierra Leone": "Sierra Leona",
    "Singapour": "Singapur",
    "Saint-Martin (partie néerlandaise)": "San Martín (parte neerlandesa)",
    "Slovaquie": "Eslovaquia",
    "Slovénie": "Eslovenia",
    "Îles Salomon": "Islas Salomón",
    "Somalie": "Somalia",
    "Afrique du Sud": "Sudáfrica",
    "Géorgie du Sud-et-les Îles Sandwich du Sud": "Islas Georgias del Sur y Sandwich del Sur",
    "Soudan du Sud": "Sudán del Sur",
    "Espagne": "España",
    "Sri Lanka": "Sri Lanka",
    "Soudan": "Sudán",
    "Suriname": "Surinam",
    "Svalbard et Île Jan Mayen": "Svalbard y Jan Mayen",
    "Eswatini": "Esuatini",
    "Suède": "Suecia",
    "Suisse": "Suiza",
    "Syrie": "Siria",
    "Taïwan": "Taiwán",
    "Tadjikistan": "Tayikistán",
    "Tanzanie": "Tanzania",
    "Thaïlande": "Tailandia",
    "Timor oriental": "Timor Oriental",
    "Togo": "Togo",
    "Tokelau": "Tokelau",
    "Tonga": "Tonga",
    "Trinité-et-Tobago": "Trinidad y Tobago",
    "Tunisie": "Túnez",
    "Turquie": "Turquía",
    "Turkménistan": "Turkmenistán",
    "Îles Turques-et-Caïques": "Islas Turcas y Caicos",
    "Tuvalu": "Tuvalu",
    "Ouganda": "Uganda",
    "Ukraine": "Ucrania",
    "Émirats arabes unis": "Emiratos Árabes Unidos",
    "Royaume-Uni": "Reino Unido",
    "États-Unis": "Estados Unidos",
    "Îles mineures éloignées des États-Unis": "Islas Ultramarinas Menores de Estados Unidos",
    "Uruguay": "Uruguay",
    "Ouzbékistan": "Uzbekistán",
    "Vanuatu": "Vanuatu",
    "Venezuela": "Venezuela",
    "Viêt Nam": "Vietnam",
    "Îles Vierges britanniques": "Islas Vírgenes Británicas",
    "Îles Vierges des États-Unis": "Islas Vírgenes de EE. UU.",
    "Wallis-et-Futuna": "Wallis y Futuna",
    "Sahara occidental": "Sahara Occidental",
    "Yémen": "Yemen",
    "Zambie": "Zambia",
    "Zimbabwe": "Zimbabue",

    "Vous allez recevoir un sms !" : "¡Recibirás un SMS!",
    "Dans quelques instants, vous recevrez un sms. Cliquez sur le lien, et envoyez vos photos." : "En unos momentos, recibirás un SMS. Haz clic en el enlace y envía tus fotos.",

    "Changer de Thématique" : "Cambiar tema",

    "Couvertures pour votre album" : "Portadas para tu álbum",
    "Modèles pour vos pages" : "Plantillas para tus páginas",

    "Thème" : "Tema",
    "Taille" : "Tamaño",
    "Finition" : "Acabado",

    "Un Instant ..." : "Un momento",
    "C'est presque bon !" : "¡Ya casi estamos!",
    "Je sélectionne les meilleures photos" : "Estoy seleccionando las mejores fotos",
    "Je créé votre histoire ..." : "Estoy creando tu historia...",

    "Mise en page aléatoire" : "Diseño de página aleatorio",

    "<b>$</b> vous a envoyé" : "<b>$</b> te ha enviado",
    "Refuser" : "Rechazar",
    "Voir les photos" : "Ver las fotos",
    "Vous allez perdre les photos partagées de $." : "Perderás las fotos compartidas de $.",
    "Êtes vous sûr de vouloir quitter?" : "¿Estás seguro de querer salir?",
    "Vous allez perdre les photos partagées de $. Êtes vous sûr de vouloir quitter?" : "Perderás las fotos compartidas de $. ¿Estás seguro de querer salir?",
    "Sélectionnez les photos que vous souhaitez garder" : "Selecciona las fotos que quieres guardar",
    "Tout sélectionner ($)" : "Seleccionar todo ($)",
    "Vous pouvez sélectionner $ photos maximum." : "Puede seleccionar un máximo de $ fotos.",
    "Tout déselectionner ($)" : "Deseleccionar todo ($)",
    "Valider ($)" : "Confirmar ($)",

    "Appuyez ici pour tourner les pages":"Pincha aquí para pasar las páginas",
    "Au cas ou...":"Por si acaso...",
    "Vous pouvez annulez vos<br>modifications ici":"Puedes cancelar tus<br>modificaciones aquí",
    "On Commence ?":"¿Empezamos?",
    //"Choisissez la couverture<br>de votre album":"Elige la portada<br>de tu álbum",
    "Commencez par sélectionner vos photos !" : "¡Empiece seleccionando sus fotos!",
    "Personne":"Persona",
    "Trier par personne":"Ordenar por persona",
    "Sélectionnez vos photos depuis :":"Selecciona tus fotos desde :",
    "Ajouter 2 pages":"Añadir 2 páginas",
    "Couvertures":"Portadas",
    "Texte de la tranche":"Texto de la portada del álbum",
    "Besoin de Recadrer ?":"¿Necesitas recortar?",
    "Appuyez une seconde fois<br>sur la photo.":"Pincha la foto<br>una segunda vez.",
    "Classique":"Clásico",
    "Mises en page":"Diseños",
    "Images":"Imágenes",
    "Toutes":"Todas",
    "Non Utilisées":"No utilizadas",
    "Remplacer":"Reemplazar",
    "Effets":"Efectos",
    "Valider":"Confirmar",
    "Zoomer/Recadrez":"Zoom/Recortar",
    "Supprimer 2 pages":"Eliminar 2 páginas",
    
    'Vos Creations' : 'Tus Creaciones',

    "Corriger" : "Corregir",

    "Nombre de photos insuffisant" : "Número insuficiente de fotos",
    "Veuillez sélectionner au minimum 24 photos." : "Por favor, seleccione al menos 24 fotos.",

    "Importez vos photos en cliquant sur le bouton ici." : "Importa tus fotos haciendo clic en el botón aquí.",
    "Ajoutez une photo" : "Añadir una foto",
    "Appuyez sur une photo ou faîtes-la glisser vers votre page" : "Toca una foto o arrástrala a tu página",

    "Quel type d'album souhaitez-vous créer?" : "¿Qué tipo de álbum desea crear?",

    "Tirage $" : "Revelados $",
    "$/$ photos" : "$/$ fotos",
    "$ photos" : "$ fotos",

    "Nombre de photo maximum" : "Número máximo de fotos",
    "Vous avez atteint le nombre maximum de photos" : "Has alcanzado el número máximo de fotos",

    "Choisissez la taille de votre cadre" : "Elige el tamaño de tu marco",

    "Passer": "Saltar",

    "Cadre Photo": "Marco de fotos",
    "Poster Photo" : "Póster de fotos",

    "Ajoutez vos photos<br>en cliquant ici" : "Añade tus fotos<br>haciendo clic aquí",

    "Choisissez les photos<br>à ajouter à votre cadre" : "Elige las fotos<br>que quieres añadir a tu marco",

    "Votre album n'a pas été sauvegardé. Etes-vous sûre de vouloir quitter cette page ?" : "Tu álbum no ha sido guardado. ¿Estás segura de que quieres salir de esta página?",
    "ATTENTION : en quittant sans sauvegarder vous risquez de perdre un partie de votre travail. Veuillez utiliser le bouton QUITTER pour quitter en sauvegardant votre travail." : "ATENCIÓN: Si sales sin guardar, podrías perder parte de tu trabajo. Usa el botón SALIR para guardar y salir.",
    
    "Aller au panier (+ $ €)": "Ir al carrito (+ $ €)",
    "Continuer sans cadre" : "Continuar sin marco",
    "Continuer sans box" : "Continuar sin caja",

    "Et si on rajoutait un joli papier en plus ?": "¿Y si añadimos un bonito papel?",
    "Et pourquoi pas une box pour ranger vos photos ?": "¿Y por qué no una caja para guardar tus fotos?",
    "Pourquoi pas un cadre autour de votre chef d'oeuvre ?": "¿Qué tal un marco para tu obra maestra?",

    "Pour photos 10 x 10cm" : "Para fotos de 10 x 10 cm",
    "Pour photos 15 x 10cm" : "Para fotos de 15 x 10 cm",

    "Calendrier Bureau" : "Calendario de Escritorio",
    "Calendrier Mural" : "Calendario de Pared",

     "Ajoutez vos photos, puis déplacez-les sur vos pages": "Agrega tus fotos y colócalas en tus páginas",
    "Choisissez le mois de démarrage de votre calendrier": "Elige el mes de inicio de tu calendario",
    "Commencer": "Comenzar",
    "Janvier": "Enero",
    "Février": "Febrero",
    "Mars": "Marzo",
    "Avril": "Abril",
    "Mai": "Mayo",
    "Juin": "Junio",
    "Juillet": "Julio",
    "Août": "Agosto",
    "Septembre": "Septiembre",
    "Octobre": "Octubre",
    "Novembre": "Noviembre",
    "Décembre": "Diciembre",
    "Modifiez votre évènement": "Edita tu evento",
    "Vos dates": "Tus fechas",
    "Vos dates préférées méritent une place ici : anniversaires, voyages, bons moments !": "¡Tus fechas favoritas merecen un lugar aquí: cumpleaños, viajes, buenos momentos!",
    "Ajoutez un événement en sélectionnant une date dans le calendrier." : "Añade un evento seleccionando una fecha en el calendario.",
    "Ajoutez une date": "Agrega una fecha",
    "Sélectionnez la date": "Selecciona la fecha",
    "Entrez votre évènement": "Introduce tu evento",
    "Modifiez votre évènement": "Edita tu evento",

    "Lundi": "Lunes",
    "Mardi": "Martes",
    "Mercredi": "Miércoles",
    "Jeudi": "Jueves",
    "Vendredi": "Viernes",
    "Samedi": "Sábado",
    "Dimanche": "Domingo",

    "Cliquer pour ajouter une photo" : "Haga clic para añadir una foto",
    "Ajouter vos photos ici" : "Añada sus fotos aquí",
    "Choisissez votre modèle<br>Puis ajouter vos photos" : "Elija su modelo<br>Luego añada sus fotos",

    "Votre photo n'a pu être transformée, veuillez re-éssayer dans quelques instants." : "Su foto no pudo ser transformada, por favor inténtelo de nuevo en unos momentos.",

    "Super photo, félicitations !" : "¡Excelente foto, felicidades!",
    "Un peu de magie..." : "Un poquito de magia...",
    "Je crée votre poster..." : "Estoy creando su póster...",
    "On y est presque..." : "Ya casi estamos...",
    "C'est prêt !" : "¡Está listo!",

    "De préférence une photo de portrait avec des visages visibles" : "Preferiblemente una foto de retrato con rostros visibles",

    "$ photos minimum" : "$ fotos mínimo",
    "Tirage Photo" : "Impresión de fotos",
    "Recadrez votre photo si besoin" : "Recorta tu foto si es necesario",
    "Choisissez la finition de votre poster" : "Elige el acabado de tu póster",
    "A partir de" : "A partir de",

    "Choisissez la taille de votre poster" : "Elige el tamaño de tu póster",
    "Changer" : "Cambiar",
   
    "Cliquez pour changer la finition" : "Haz clic para cambiar el acabado",
    "On vous propose 4 finitions" : "Te ofrecemos 4 acabados",
    "Pour la taille, on part sur quoi ?" : "¿Qué tamaño prefieres?",
    "Souhaitez-vous un cadre ?" : "¿Deseas un marco?",
    "A partir de" : "Desde",

    // poster / calendar
    "Modèles pour votre affiche" : "Diseños para su póster",
    "Événements" : "Eventos",
    "Appuyez 2 fois sur la photo" : "Pincha la foto dos veces",
    "Recadrez ?" : "¿Recortar?",
    "$ photos n'ont pu être envoyées" : "No se han podido enviar $ fotos",
    "1 photo n'a pu être envoyée" : "No se ha podido enviar 1 foto",
    "L'envoi n'était pas terminé quand la page a été fermée, j'ai donc retiré les tirages concernés. Ajoutez à nouveau vos photos, et gardez cette page ouverte jusqu'à la fin de l'envoi." : "El envío no había terminado cuando se cerró la página, así que he quitado las copias afectadas. Vuelva a añadir sus fotos y mantenga esta página abierta hasta que termine el envío.",
    "Envoi $ %" : "Envío $ %",

    // gomme magique (shared.popups.MagicEraserPopup)
    "Gomme magique" : "Borrador mágico",
    "Gommer" : "Borrar",
    "Gommer un élément" : "Borrar un elemento",
    "Comment ça marche ?" : "¿Cómo funciona?",
    "Tout effacer" : "Borrar todo",
    "Gommer la zone" : "Borrar la zona",
    "Gommage…" : "Borrando…",
    "Entourez la zone à gommer : tracez un contour fermé autour de l'élément" : "Rodee la zona que desea borrar: trace un contorno cerrado alrededor del elemento",
    "L'intérieur du contour sera gommé. Vous pouvez entourer une autre zone." : "Se borrará el interior del contorno. Puede rodear otra zona.",
    "Ne fermez pas la fenêtre, c'est presque fini." : "No cierre la ventana, ya casi está.",
    "Voici le résultat. Gardez-le, ou recommencez" : "Este es el resultado. Consérvelo o vuelva a empezar",
    "Entourez un élément pour le supprimer de votre photo." : "Rodee un elemento para eliminarlo de su foto.",
    "Recommencer" : "Volver a empezar",
    "Garder" : "Conservar",
    "Avant" : "Antes",
    "Après" : "Después",
    "Veuillez vous reconnecter." : "Vuelve a iniciar sesión.",
    "Cette photo n'est pas accessible." : "Esta foto no está disponible.",
    "La gomme magique est momentanément indisponible." : "El borrador mágico no está disponible por el momento.",
    "Cette version de la photo ne peut pas être retouchée." : "Esta versión de la foto no se puede retocar.",
    "Le tracé n'a pas pu être lu, veuillez réessayer." : "No se ha podido leer el trazo, inténtalo de nuevo.",
    "Veuillez patienter une minute avant le prochain effacement." : "Espera un minuto antes del próximo borrado.",
    "Vous avez atteint la limite d'effacements pour aujourd'hui." : "Has alcanzado el límite de borrados de hoy.",
    "Le traitement prend trop de temps, veuillez réessayer." : "El procesamiento tarda demasiado, inténtalo de nuevo.",
    "L'effacement a échoué, veuillez réessayer." : "El borrado ha fallado, inténtalo de nuevo.",

    // posters : Aperçu 3D (shared.popups.WallPreviewPopup)
    "Aperçu 3D" : "Vista previa 3D",
    "Voir votre poster sur un mur" : "Ver tu póster en una pared",
    "Poster seul" : "Solo póster",
    "Poster" : "Póster",
    "Cadre bois" : "Marco de madera",
    "Bois" : "Madera",
    "Cadre noir" : "Marco negro",
    "Noir" : "Negro",
    "Cadre blanc" : "Marco blanco",
    "Blanc" : "Blanco",
    "Salon" : "Salón",
    "Chambre" : "Dormitorio",
    "Cuisine" : "Cocina",
    "Salon avec canapé rose" : "Salón con sofá rosa",
    "Chambre avec lit et commode" : "Dormitorio con cama y cómoda",
    "Cuisine au mur rose" : "Cocina con pared rosa",
    "Poster encadré" : "Póster enmarcado",
    "Glissez pour faire pivoter · molette pour zoomer" : "Arrastra para girar · rueda para hacer zoom",
    "Molette pour zoomer" : "Rueda para hacer zoom",
    "Vue d'ensemble" : "Vista general",
    "De près" : "De cerca",
    "Dimensions" : "Dimensiones",
    "Pièce" : "Estancia",
    "Ensemble" : "General",
    "Afficher les dimensions" : "Mostrar las dimensiones",
    "Préparation de l'aperçu…" : "Preparando la vista previa…",

    // posters : the size and finish screens, the editor's options bar
    "Les aperçus sont à la même échelle : comparez d'un coup d'œil." : "Las vistas previas están a la misma escala: compárelas de un vistazo.",
    "Choisissez votre finition" : "Elija su acabado",
    "Comment voulez-vous l'afficher ?" : "¿Cómo quiere exponerlo?",
    "Aperçu avec votre photo, au format $." : "Vista previa con su foto, en formato $.",
    "Le + choisi" : "El más elegido",
    "Pas disponible dans cette taille" : "No disponible en este tamaño",
    "Options du poster" : "Opciones del póster",

    // album check before ordering (shared.panels.AlbumCheckPanel)
    "Vérification en cours…" : "Comprobando…",
    "Nous passons votre album en revue avant l'impression." : "Revisamos su álbum antes de la impresión.",
    "Votre conseillère Flexilivre" : "Su asesora Flexilivre",
    "Votre album a été vérifié" : "Su álbum ha sido revisado",
    "Corriger mon album" : "Corregir mi álbum",
    "complété" : "completado",
    "Tout est parfait, votre album est prêt !" : "¡Todo está perfecto, su álbum está listo!",
    "Vous y êtes presque !" : "¡Ya casi está!",
    "Encore un petit effort !" : "¡Un pequeño esfuerzo más!",
    "Votre album prend forme" : "Su álbum toma forma",
    "Vérification des pages" : "Revisión de las páginas",
    "Pages remplies" : "Páginas completas",
    "Nombre de pages" : "Número de páginas",
    "1 zone photo vide" : "1 zona de foto vacía",
    "$ zones photo vides" : "$ zonas de foto vacías",
    "imprimées en blanc si vous commandez" : "se imprimirán en blanco si hace el pedido",
    "1 page vide" : "1 página vacía",
    "$ pages vides" : "$ páginas vacías",
    "Une feuille sera ajoutée à la fin" : "Se añadirá una hoja al final",
    "le nombre de pages n'est pas un multiple de 4" : "el número de páginas no es múltiplo de 4",
    "Pages concernées" : "Páginas afectadas",
    "p. $" : "p. $",
    "$ : validé" : "$: validado",
    "$ : problème détecté" : "$: problema detectado",

    // first pages added (common.popups.AddPagePopup)
    "Conseillère Flexilivre" : "Asesora Flexilivre",
    "Psst ! $ pages" : "¡Psst! $ páginas",
    "Un album se fait par <strong>4 pages</strong>. Sinon, on complète avec des pages blanches lors de la fabrication." : "Un álbum se hace de <strong>4 en 4 páginas</strong>. Si no, completamos con páginas en blanco durante la fabricación.",
    "OK, compris" : "Vale, entendido",
});
